<shared-modal-type-dynamic-height [modalData]="modalData" [center]="true" [mobilePreserve]="true" [size]="size"
    (onCloseClick)="handleCloseClick($event)" class="modal-for-delete-profile">

    <ng-template #isAuthorized>
        <shared-header [center]="true" [brandAccent]="true" type="5" marginTop="md" marginBottom="none"
            class="modal-for-delete-profile__sub-h">
            PLEASE CONFIRM
        </shared-header>
        <shared-header [center]="true" class="modal-for-delete-profile__h" type="3" marginTop="xs" marginBottom="md">
            Are you sure you want to<br /> delete your profile?
        </shared-header>

        <div class="modal-for-delete-profile__content">
            You cannot undo this action. So please<br />think twice before hitting that delete button!<br />

            <shared-link class="modal-for-delete-profile__link" (onClick)="handleContactClick($event)"
                [emphasis]="false">
                Contact us
            </shared-link>
        </div>

        <div class="modal-for-delete-profile__actions">
            <ng-template #twoColumnsLeft>
                <shared-btn feel="secondary" [width]="'extended'" size="lg" (onClick)="handleNoWayClick($event)">
                    No way!
                </shared-btn>
            </ng-template>

            <ng-template #twoColumnsRight>
                <shared-btn [width]="'extended'" [loading]="loading$ | async" size="lg"
                    (onClick)="handleDeleteProfileClick($event)">
                    Delete Profile
                </shared-btn>
            </ng-template>

            <shared-two-columns [left]="twoColumnsLeft" [right]="twoColumnsRight"></shared-two-columns>
        </div>
    </ng-template>

    <ng-template #isDeleted>

        <div class="modal-for-delete-profile__animation" directive-lottie="profile-delete"></div>

        <shared-header [center]="true" class="modal-for-delete-profile__h" type="3" marginTop="xs" marginBottom="md">
            It's a sad day :(<br />Your profile was deleted.
        </shared-header>

        <div class="modal-for-delete-profile__content">
            Please get in thouch if you need any further assistance<br />

            <shared-link class="modal-for-delete-profile__link" (onClick)="handleContactClick($event)"
                [emphasis]="false">
                Contact us
            </shared-link>
        </div>
    </ng-template>

    <ng-container *ngTemplateOutlet="(isAuthorized$ | async) === true ? isAuthorized : isDeleted"></ng-container>

</shared-modal-type-dynamic-height>
